import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { iconColor } from 'utils/helpers'

export const ExpandIcon = () => {
    const { darkMode } = useSelector((state: RootState) => state.globals)
    const fill = iconColor(darkMode)
    return <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.3212 1.9861C5.59085 1.72137 5.59085 1.29215 5.3212 1.02742C5.05155 0.76269 4.61437 0.76269 4.34472 1.02742L0.201864 5.09476C-0.0677836 5.35949 -0.0677836 5.78871 0.201864 6.05344L4.34472 10.1208C4.61437 10.3855 5.05155 10.3855 5.3212 10.1208C5.59085 9.85605 5.59085 9.42683 5.3212 9.1621L1.66658 5.5741L5.3212 1.9861Z" fill={fill} />
    </svg>


}